// These match the cert-server
export enum SSEEventType {
    EndpointRequest = 'endpoint_request',
    EndpointResponse = 'endpoint_response',
    Error = 'error',
    GotReboot = 'got_reboot',
    Heartbeat = 'heartbeat',
    Info = 'info',
    MQTTConnect = 'mqtt_connect',
    MQTTMessage = 'mqtt_message',
    MQTTSubscribe = 'mqtt_subscription',
    NeedReboot = 'need_reboot',
    RunGroupStart = 'run_group_start',
    RunGroupStop = 'run_group_stop',
    RunStart = 'run_start',
    RunStop = 'run_stop',
    TestState = 'test_state',
    TestsState = 'tests_state',
    EventMessageValidated = 'message_validated',
    EventMessageValidationSummary = 'message_validation_summary',
}
